import { getAiOutput, updateAiOutput } from '../ai-output.api';
import { AiOutput, UpdateAiOutputParams } from '../ai-output.types';

export const getNextBestActionsAiOutput = async (clientId: string | number): Promise<AiOutput> => {
	return getAiOutput(clientId, 'next_best_actions');
};

export const updateNextBestActionsAiOutput = async ({
	clientId,
	payload,
}: UpdateAiOutputParams): Promise<void> => {
	return updateAiOutput('next_best_actions', clientId, payload);
};
